function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "m280 192a8 8 0 0 1 -8-8v-80a56 56 0 0 0 -112 0v80a8 8 0 0 1 -16 0v-80a72 72 0 0 1 144 0v80a8 8 0 0 1 -8 8z",
  fill: "#dadcde"
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  d: "m296 472h-272l16-320h240z",
  fill: "#eb423f"
});

var _ref4 =
/*#__PURE__*/
React.createElement("path", {
  d: "m360 472h-64l-16-320h64z",
  fill: "#d13330"
});

var _ref5 =
/*#__PURE__*/
React.createElement("path", {
  d: "m328.47 431.99c-.16.01-.32.01-.48.01a8 8 0 0 1 -7.98-7.53l-16-272c-.01-.16-.01-.31-.01-.47h16.02l15.97 271.53a8.007 8.007 0 0 1 -7.52 8.46z",
  fill: "#a82a27"
});

var _ref6 =
/*#__PURE__*/
React.createElement("path", {
  d: "m488 472h-64l-1-12.93v-.01l-15-195.06h64l14.75 191.69v.01z",
  fill: "#eba72e"
});

var _ref7 =
/*#__PURE__*/
React.createElement("path", {
  d: "m456.8 431.96a7.322 7.322 0 0 1 -.81.04 8 8 0 0 1 -7.95-7.2l-.29-2.86-15.71-157.14a7.143 7.143 0 0 1 -.04-.8h16.04l15.72 157.21.2 1.99a8 8 0 0 1 -7.16 8.76z",
  fill: "#e09f2c"
});

var _ref8 =
/*#__PURE__*/
React.createElement("path", {
  d: "m488 472h-9.62l-22.38-33.58-22.38 33.58h-9.62l-1-12.93v-.01l24.75-37.12 1.59-2.38a8.01 8.01 0 0 1 13.32 0l1.1 1.65 22.99 34.48v.01z",
  fill: "#e09f2c"
});

var _ref9 =
/*#__PURE__*/
React.createElement("path", {
  d: "m424 472h-208l16-208h176z",
  fill: "#f7b030"
});

var _ref10 =
/*#__PURE__*/
React.createElement("path", {
  d: "m328 416h-16a40.045 40.045 0 0 1 -40-40v-64a8 8 0 0 1 16 0v64a24.027 24.027 0 0 0 24 24h16a24.027 24.027 0 0 0 24-24v-64a8 8 0 0 1 16 0v64a40.045 40.045 0 0 1 -40 40z",
  fill: "#e9eef2"
});

var _ref11 =
/*#__PURE__*/
React.createElement("path", {
  d: "m96 184h16v48h-16z",
  fill: "#dadcde"
});

var _ref12 =
/*#__PURE__*/
React.createElement("path", {
  d: "m104 192a8 8 0 0 1 -8-8v-80a72 72 0 0 1 144 0v80a8 8 0 0 1 -16 0v-80a56 56 0 0 0 -112 0v80a8 8 0 0 1 -8 8z",
  fill: "#e9eef2"
});

var _ref13 =
/*#__PURE__*/
React.createElement("path", {
  d: "m128 296h-48v-64l24-16 24 16z",
  fill: "#f7b030"
});

var SvgOnlineShopping = function SvgOnlineShopping(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    id: "Flat",
    height: 512,
    viewBox: "0 0 512 512",
    width: 512,
    ref: svgRef
  }, props), _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgOnlineShopping, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/online-shopping.aa321943.svg";
export { ForwardRef as ReactComponent };